<template>
  <li 
    class="template__item p-3 mb-3">
    <div class="d-flex align-items-center justify-content-between">
      <div class="contents">
        <div
          v-if="categoryName"
          class="category-name-wrapper">
          <span class="category-name">
            {{ categoryName }}
          </span>
        </div>
        <p class="d-flex align-items-center">
          <span
            class="template__color mr-1 d-inline-block"
            :style="{ backgroundColor: template.color }" />
          <span class="d-inline-block ml-1">
            {{ template.sortOrder | prettySortNo }}
            {{ template.title }}
          </span>
        </p>
      </div>
      <slot />
    </div>
  </li>
</template>

<script>
export default {
  props: {
    template: {
      type: Object,
      required: true,
    },
  },
  computed: {
    categoryName() {
      if (!this.template.category) {
        return null
      }
      return this.template.category.name
    }
  }
}
</script>

<style lang="scss" scoped>
.template {
  &__item {
    position: relative;
    background-color: $white;
    border-radius: 8px;
    font-weight: bold;

    .category-name-wrapper {
      font-weight: normal;
      font-size: $fs-s;
      margin: -5px 0 7px;

      .category-name {
        background-color: $grey03;
        padding: 0 8px;
        height: calc($fs-s + 8px);
      }
    }
  }

  &__icon{
    vertical-align: middle;
    display: inline-block;
  }

  &__btn {
    position: relative;
    box-shadow: 1px 2px 6px $grey05;
    padding: 2px;
    line-height: 27px;
    @media screen and (min-width:768px) {
      padding: auto;
      line-height: auto;
    }
  }

  &__btn-icon{
    display: inline-block;
    vertical-align: text-bottom;
    font-size: 20px;
  }

  &__color {
    width: 18px;
    min-width: 18px;
    height: 25px;
  }
}
</style>